module.exports = __webpack_public_path__ + "img/1.dd18e84a.jpg";